import {isoToLocalInputValue} from '../journal/schedule.js';

function required(value,label,max=120){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function validZone(value,label){
  const zone=required(value,label);
  try{new Intl.DateTimeFormat('en',{timeZone:zone}).format(new Date(0));}
  catch{throw new TypeError('Invalid IANA timezone');}
  return zone;
}

function wallMillis(value){
  const match=/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(String(value||''));
  if(!match)return null;
  return Date.UTC(
    Number(match[1]),Number(match[2])-1,Number(match[3]),
    Number(match[4]),Number(match[5]),0,0
  );
}

export function plannerTimezoneReview(snapshot,newTimeZone,{
  materialThresholdMinutes=15
}={}){
  if(!snapshot||snapshot.snapshotVersion!==1){
    return Object.freeze({
      status:'not_applicable',
      requiresReview:false,
      originatingTimeZone:null,
      currentTimeZone:validZone(newTimeZone,'newTimeZone')
    });
  }
  const origin=validZone(snapshot.timeZone,'snapshot.timeZone');
  const current=validZone(newTimeZone,'newTimeZone');
  const target=required(snapshot.targetReadyAt,'snapshot.targetReadyAt',180);
  if(Number.isNaN(Date.parse(target)))throw new TypeError('snapshot.targetReadyAt must be an ISO timestamp');

  const originLocal=isoToLocalInputValue(target,{timeZone:origin});
  const currentLocal=isoToLocalInputValue(target,{timeZone:current});
  const originMillis=wallMillis(originLocal);
  const currentMillis=wallMillis(currentLocal);
  const wallShiftMinutes=originMillis!=null&&currentMillis!=null
    ?Math.round((currentMillis-originMillis)/60000)
    :null;
  const dateChanged=originLocal.slice(0,10)!==currentLocal.slice(0,10);
  const threshold=Math.max(0,Number(materialThresholdMinutes)||0);
  const material=dateChanged
    ||wallShiftMinutes==null
    ||Math.abs(wallShiftMinutes)>=threshold;

  let changedBlockCount=0;
  for(const block of snapshot.blocks||[]){
    const at=block?.applied?.startAt||block?.applied?.endAt;
    if(!at)continue;
    if(isoToLocalInputValue(at,{timeZone:origin})!==isoToLocalInputValue(at,{timeZone:current})){
      changedBlockCount+=1;
    }
  }

  return Object.freeze({
    status:origin===current?'same_timezone':material?'review_required':'display_shift_small',
    requiresReview:origin!==current&&material,
    originatingTimeZone:origin,
    currentTimeZone:current,
    targetReadyAt:target,
    originatingTargetLocal:originLocal,
    currentTargetLocal:currentLocal,
    wallShiftMinutes,
    dateChanged,
    changedBlockCount
  });
}
